var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-range-custom-plugin-biz',{attrs:{"initRange":_vm.storedDateRange,"captions":_vm.captions,"months":_vm.months,"shortDays":_vm.shortDays,"rightToLeft":true,"hasDateToUse":_vm.hasDateToUse,"initDateToUse":_vm.dateToUse,"dateToUseValues":_vm.dateToUseValues},on:{"applyrange":_vm.applyRange,"cleardaterange":_vm.resetRange}})
}
var staticRenderFns = []

export { render, staticRenderFns }